import {CsIndexedDbJsHelper} from "./CsIndexedDbJsHelper";

export class CsContextKeyHelper {
  private readonly _CsContextKeyName: string = "CsContextKey";
  
  public async getCsContextKey(): Promise<string | null> {
    console.log("getCsContextKey: ENTERED");
    try {
      const csIndexedDbJsHelper = new CsIndexedDbJsHelper();
      let csContextKey = await csIndexedDbJsHelper.getValueByKey(this._CsContextKeyName);
      console.log("getCsContextKey: csContextKey=", csContextKey);
      
      if (csContextKey) {
        // const csContextKey = JSON.parse(resultString) as CsContextKey;
        console.log("getCsContextKey: Returning existing signature", csContextKey);
        window.__CsContextKey = csContextKey;
        return csContextKey;
      }

      console.log("getCsContextKey: Creating new csContextKey");
      // const csContextKey = new CsContextKey();
      csContextKey = crypto.randomUUID();
      console.log("getCsContextKey: Created csContextKey:", csContextKey);
      
      await csIndexedDbJsHelper.setValueByKey(this._CsContextKeyName, csContextKey);
      window.__CsContextKey = csContextKey;
      console.log("getCsContextKey: Saved and returning new signature", csContextKey);
      
      return csContextKey;
    }
    catch (err) {
      console.error("getCsContextKey: ERROR caught", err);
      return null;
    }
  }
}
